export const CHARGES_LIST_REQUEST = "CHARGES_LIST_REQUEST";
export const CHARGES_LIST_SUCCESS = "CHARGES_LIST_SUCCESS";
export const CHARGES_LIST_ERROR = "CHARGES_LIST_ERROR";
export const CHARGES_LIST_RESET = "CHARGES_LIST_RESET";
